import RpIcon from "@/components/RpIcon";
import CardLabelDialog from "@/pages/card/components/CardLabelDialog/CardLabelDialog";
import CardLimitAmountModal from "@/pages/components/CardLimitAmountModal";
import FreezeCardModal from "@/pages/components/FreezeCardModal";
import {IconButton, Stack, Typography, Box, useTheme} from "@mui/material";
import { useBoolean } from "ahooks";
import { useTranslation } from "react-i18next";

import styles from "./index.module.less";
import {createSearchParams, useNavigate} from "react-router-dom";
import { CARD_STATUS } from "@/constant/Constant.ts";
import useWindowSize from "@/hook/useWindowSize";
import { useMemo } from "react";
import RouteConstant from "@/constant/RouteConstant";

interface Props {
  card: any;
  frozen: boolean;
  onComplete?: () => void;
}

export default function Settings({card, frozen, onComplete}: Props) {
  const {t} = useTranslation();
  const {isMobile} = useWindowSize();
  const navigate = useNavigate();
  const theme = useTheme()
  const [isCardlabelModalOpen, cardlabelModalOperate] = useBoolean(false);
  const [isCarFreezeModalOpen, cardFreezeModaOperate] = useBoolean(false);
  const [isCardLimitAmountModal, cardLimitAmountModalOperate] =
    useBoolean(false);

  const isCardFreeze = useMemo(() => {
    return card?.cardStatus === CARD_STATUS.FROZEN;
  }, [card])

  // const canOperate = useMemo(() => {
  //   if (card?.cardStatus != )
  // }, [card]);

  const _handleLimit = () => {
    // //TODO
    // setChildNode(<Limit onClose={handleClose} />);
    // setOpen(true);
    cardLimitAmountModalOperate.setTrue();
  };
  const _handFrozen = () => {
    //TODO
    // setChildNode(<Freeze onClose={handleClose} />);
    // setOpen(true);
    cardFreezeModaOperate.setTrue();
  };
  const _handleBill = () => {
    if (!card) {
      return;
    }
    navigate(`/card/bill_list?cardId=${card.cardId}`);
  };
  const _handleSettings = () => {
    if (!card) {
      return;
    }
    let _card = {
      ...card
    }
    let keys = Object.keys(_card);
    let ret = {}
    keys.forEach(_ => {
      ret[_] = _card[_] || ''
    })

    navigate({
      pathname: RouteConstant.CARD_MODIFY,
      search: createSearchParams({
        ...ret
      }).toString()
    });
    // navigate(`/card_management/modify?cardId=${card.cardId}`, {
    //   state: {card: card},
    // });
  };

  return (
    <>
      <Stack className={styles.wrap}>
        <Stack className={styles.list} direction="row">
          <Stack
            gap={"8px"}
            direction="column"
            alignItems="center"
          >
            <IconButton
              sx={{ padding: '12px' }}
              onClick={_handleLimit}
              disabled={isCardFreeze}
              className={"icon"}>
              <RpIcon icon="sliders" size={24}/>
            </IconButton>
            <Box className={`${isCardFreeze ? 'label' : 'text-action'}`}>{t("limit")}</Box>
          </Stack>

          <Stack
            gap={"8px"}
            direction="column"
            alignItems="center"
          >
            <IconButton
              sx={{
                padding: '12px',
                color: isCardFreeze ? theme.palette.background.default : theme.palette.text.primary,
                backgroundColor: isCardFreeze ? theme.palette.brand.main : theme.palette.background.paper,
                '&:hover': {
                  color: isCardFreeze ? theme.palette.background.default : theme.palette.text.primary,
                  backgroundColor: isCardFreeze ? theme.palette.brand.main : theme.palette.background.paper,
                }
            }}
              onClick={_handFrozen}
              className={"icon"}>
              <RpIcon icon={frozen ? "freeze" : "freeze"} size={24}/>
            </IconButton>
            <Box className="text-action">
              {!isCardFreeze ? t("freeze") : t("unfreeze")}
            </Box>
          </Stack>

          <Stack
            gap={"8px"}
            direction="column"
            alignItems="center"
          >
            <IconButton
              sx={{ padding: '12px' }}
              onClick={_handleBill}
              className={"icon"}>
              <RpIcon icon="file" size={24}/>
            </IconButton>
            <Box className="text-action">{t("bill")}</Box>
          </Stack>

          <Stack
            gap={"8px"}
            direction="column"
            alignItems="center"
          >
            <IconButton
              sx={{ padding: '12px' }}
              onClick={_handleSettings}
              disabled={isCardFreeze}
              className={"icon"}>
              <RpIcon icon="setting" size={24}/>
            </IconButton>
            <Box className={`${isCardFreeze ? 'label' : 'text-action'}`}>{t("setting")}</Box>
          </Stack>
        </Stack>
      </Stack>
      <CardLabelDialog
        open={isCardlabelModalOpen}
        onClose={() => {
          cardlabelModalOperate.setFalse();
        }}
        card={card}
      ></CardLabelDialog>
      <FreezeCardModal
        open={isCarFreezeModalOpen}
        isFreeze={true}
        reresh={() => {
        }}
        onClose={() => {
          cardFreezeModaOperate.setFalse();
        }}
        onComplete={() => {
          cardFreezeModaOperate.setFalse();
          onComplete && onComplete()
        }}
        card={card}
      />
      <CardLimitAmountModal
        open={isCardLimitAmountModal}
        reresh={() => {
        }}
        onClose={() => {
          cardLimitAmountModalOperate.setFalse();
        }}
        card={card}
      />
      {/*<CardFreezeDialog open={isCarFreezeModalOpen} onClose={() => cardFreezeModaOperate.setFalse()} card={card} />*/}
    </>
  );
}
